import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

import { DEPART_DIRECTION } from '../../../constants';

function sortOptionSelected({ direction, previousType, type }) {
    const property = {
        sort_name: type,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'select',
        category: 'react_search',
        label: 'sort_by',
        property,
    });

    amplitude.track('search_sorted', {
        is_departing_results: direction === DEPART_DIRECTION,
        updated_from: previousType,
        updated_to: type,
    });
}

export default { sortOptionSelected };
